<template>

  <div class="container">
    <h3 class="main-title">Beneficiario</h3>
    <form @submit.prevent="submit" novalidate>
      <fieldset>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="name" :class="{'error-text': endpointErrors.name}">Nombre(s):</label>
            <input type="text" name="name" v-model.trim="$v.userInteraction.name.$model" :class="{ 'error-label': $v.userInteraction.name.$error  || endpointErrors.name }" placeholder="Nombre">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.name.required">El nombre es obligatorio</span>
              <span v-if="!$v.userInteraction.name.minLength">El nombre debe de tener más de 2 letras</span>
              <span v-if="!$v.userInteraction.name.validateAlpha">El nombre no debe contener números ni caracteres especiales</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="middleName" :class="{'error-text': endpointErrors.middle_name}">Apellido paterno:</label>
            <input type="text" name="middleName" v-model.trim="$v.userInteraction.middleName.$model" :class="{ 'error-label': $v.userInteraction.middleName.$error  || endpointErrors.middle_name }" placeholder="Apellido paterno">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.middleName.required">El apellido paterno es obligatorio</span>
              <span v-if="!$v.userInteraction.middleName.minLength">El apellido paterno debe de tener más de 2 letras</span>
              <span v-if="!$v.userInteraction.middleName.validateAlpha">El apellido paterno no debe contener números ni caracteres especiales</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="lastName" :class="{'error-text': endpointErrors.last_name}">Apellido materno:</label>
            <input type="text" name="lastName" v-model.trim="$v.userInteraction.lastName.$model" :class="{ 'error-label': $v.userInteraction.lastName.$error || endpointErrors.last_name }" placeholder="Apellido materno">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.lastName.required">El apellido materno es obligatorio</span>
              <span v-if="!$v.userInteraction.lastName.minLength">El apellido materno debe de tener más de 2 letras</span>
              <span v-if="!$v.userInteraction.lastName.validateAlpha">El apellido materno no debe contener números ni caracteres especiales</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="birthDate" :class="{'error-text': endpointErrors.birthdate}">Fecha de nacimiento:</label>
            <DatePicker
              name="birthDate"
              v-model.trim="$v.userInteraction.birthDate.$model"
              :format="dateFormat"
              :monday-first="true"
              :disabled-dates="{from: new Date(), to: new Date(1900, 0, 0)}"
              :class="{ 'error-label': $v.userInteraction.birthDate.$error ||
                endpointErrors.birthdate }"
              :language="es"
              placeholder="Fecha de nacimiento (dd-mm-aaaa)">
            </DatePicker>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.birthDate.required">
                La fecha de nacimiento es obligatoria
              </span>
              <span v-if="!$v.userInteraction.birthDate.maxLength">
                La fecha de nacimiento no debe tener más de 10 caracteres
              </span>
              <span v-if="!$v.userInteraction.birthDate.adult">
                Debe de ser mayor de 18 años
              </span>
              <span v-if="!$v.userInteraction.birthDate.formattedDate">
                El formato de fecha debe ser: dd-mm-aaaa
              </span>
            </p>
          </div>
        </div>
        <hr>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="street" :class="{'error-text': endpointErrors.street}">Calle:</label>
            <input type="text" name="street" v-model.trim="$v.userInteraction.street.$model" :class="{ 'error-label': $v.userInteraction.street.$error || endpointErrors.street }" placeholder="Calle">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.street.required">La calle es obligatoria</span>
              <span v-if="!$v.userInteraction.street.validateAddress">La calle no puede contener caracteres especiales</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="neighborhood" :class="{'error-text': endpointErrors.neighborhood}">Colonia:</label>
            <input type="text" name="neighborhood" v-model.trim="$v.userInteraction.neighborhood.$model" :class="{ 'error-label': $v.userInteraction.neighborhood.$error || endpointErrors.neighborhood }" placeholder="Colonia">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.neighborhood.required">La colonia es obligatoria</span>
              <span v-if="!$v.userInteraction.neighborhood.validateAddress">La colonia no puede contener caracteres especiales</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="externalNumber" :class="{'error-text': endpointErrors.external_number}">Número externo:</label>
            <input type="text" name="externalNumber" v-model.trim="$v.userInteraction.externalNumber.$model" :class="{ 'error-label': $v.userInteraction.externalNumber.$error || endpointErrors.external_number }" placeholder="Número externo">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.externalNumber.required">El número externo es obligatoria</span>
              <span v-if="!$v.userInteraction.externalNumber.validateAddressNumbers">El número externo no puede contener caracteres especiales ni espacios</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="internalNumber" :class="{'error-text': endpointErrors.internal_number}">Número interno:</label>
            <input type="text" name="internalNumber" v-model="$v.userInteraction.internalNumber.$model" placeholder="Número interno">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.internalNumber.validateInternalNumber">El número interno no puede contener caracteres especiales ni espacios</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="municipality" :class="{'error-text': endpointErrors.municipality}">Delegación ó municipio:</label>
            <input type="text" name="municipality" v-model.trim="$v.userInteraction.municipality.$model" :class="{ 'error-label': $v.userInteraction.municipality.$error || endpointErrors.municipality }" placeholder="Delegación ó municipio">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.municipality.required">La delegación/municipio es obligatoria</span>
              <span v-if="!$v.userInteraction.municipality.validateAlpha">La delegación/municipio no puede contener números ni caracteres especiales</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="city" :class="{'error-text': endpointErrors.city}">Ciudad:</label>
            <input type="text" name="city" v-model.trim="$v.userInteraction.city.$model" :class="{ 'error-label': $v.userInteraction.city.$error || endpointErrors.city }" placeholder="Ciudad">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.city.required">La ciudad es obligatoria</span>
              <span v-if="!$v.userInteraction.city.validateAlpha">La ciudad no puede contener números ni caracteres especiales</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="state" :class="{'error-text': endpointErrors.state}">Estado:</label>
            <span class="select">
              <select v-model.trim="$v.userInteraction.state.$model" :class="{ 'error-label': $v.userInteraction.state.$error || endpointErrors.state }">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="state in states" :key="state.pk" :value="state.pk">
                  {{ state.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.state.required">El estado es obligatorio</span>
            </p>
          </div>
          <div class="column column-xs-100 column-sm-50">
            <label for="zipCode" :class="{'error-text': endpointErrors.zip_code}">Código postal:</label>
            <input type="text" name="zipCode" v-model.trim="$v.userInteraction.zipCode.$model" :class="{ 'error-label': $v.userInteraction.zipCode.$error || endpointErrors.zip_code }" placeholder="Código postal">
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.zipCode.required">El código postal es obligatorio</span>
              <span v-if="!$v.userInteraction.zipCode.numeric">El código postal debe ser numérico</span>
              <span v-if="!$v.userInteraction.zipCode.maxLength">El código postal debe tener 5 dígitos</span>
              <span v-if="!$v.userInteraction.zipCode.minLength">El código postal debe tener 5 dígitos</span>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <button class="button float-right" @click.prevent="submit()">Siguiente</button>
          </div>
        </div>
        <div class="row">
          <div class="column box-errors">
            <p v-if="errors" class="error">El formulario tiene errores, por favor revísalos antes de seguir.
            </p>
            <p v-else-if="empty" class="error">El formulario está vacío, todos los campos son obligatorios.
            </p>
          </div>
        </div>
      </fieldset>
    </form>
  </div>

</template>

<script>

import { required, minLength, maxLength, numeric }
  from 'vuelidate/lib/validators'
import DatePicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import { format } from 'date-fns'

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

// eslint-disable-next-line no-useless-escape
const validateAddress = (field) => /^[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]+$/.test(field)
const validateAlpha = (field) => /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(field)
const validateAddressNumbers = (field) => /^[a-zA-Z0-9]+$/.test(field)

export default {
  name: 'StepBeneficiaries',
  data () {
    return {
      endpointErrors: {
        name: false,
        middle_name: false,
        last_name: false,
        birthDate: false,
        street: false,
        external_number: false,
        internal_number: false,
        neighborhood: false,
        municipality: false,
        city: false,
        zip_code: false,
        state: false
      },
      errors: false,
      empty: false,
      states: [],
      format,
      es: es,
      userInteraction: {
        name: null,
        middleName: null,
        lastName: null,
        birthDate: null,
        street: null,
        externalNumber: null,
        internalNumber: '',
        neighborhood: null,
        municipality: null,
        city: null,
        zipCode: null,
        state: ''
      }
    }
  },
  validations: {
    userInteraction: {
      name: { required, minLength: minLength(2), validateAlpha },
      middleName: { required, minLength: minLength(2), validateAlpha },
      lastName: { required, minLength: minLength(2), validateAlpha },
      birthDate: {
        required,
        adult (birthDate) {
          const userDate = new Date(birthDate)
          const newDate = Date.now() - userDate.getTime()
          const age = new Date(newDate)
          const finalAge = Math.abs(age.getUTCFullYear() - 1970)
          return (finalAge >= 18)
        },
        formattedDate (birthDate) {
          return (
            /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/.test(
              this.dateFormat(birthDate))
          )
        },
        maxLength: maxLength(10)
      },
      street: { required, validateAddress },
      externalNumber: { required, validateAddressNumbers },
      internalNumber: {
        validateInternalNumber (internalNumber) {
          if (internalNumber === '') {
            return true
          } else {
            return /^[a-zA-Z0-9]+$/.test(internalNumber)
          }
        }
      },
      neighborhood: { required, validateAddress },
      municipality: { required, validateAlpha },
      city: { required, validateAlpha },
      state: { required },
      zipCode: {
        required,
        numeric,
        maxLength: maxLength(5),
        minLength: minLength(5)
      }
    }
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  components: {
    DatePicker
  },
  methods: {
    sendDataToServer: async function () {
      let oldDate = this.dateFormat(this.userInteraction.birthDate)
      let newDate = this.reverseBirthDate(oldDate)

      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/profile/beneficiaries/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          name: this.userInteraction.name,
          middle_name: this.userInteraction.middleName,
          last_name: this.userInteraction.lastName,
          birthdate: newDate,
          address: {
            street: this.userInteraction.street,
            external_number: this.userInteraction.externalNumber,
            internal_number: this.userInteraction.internalNumber,
            neighborhood: this.userInteraction.neighborhood,
            municipality: this.userInteraction.municipality,
            city: this.userInteraction.city,
            zip_code: this.userInteraction.zipCode,
            state: this.userInteraction.state
          }
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.nextStep()
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.endpointErrors.name = ('name' in response.data)
            this.endpointErrors.middle_name = ('middle_name' in
              response.data)
            this.endpointErrors.last_name = ('last_name' in
              response.data)
            this.endpointErrors.birthdate = ('birthdate' in
              response.data)
            this.endpointErrors.street = ('street' in response.data)
            this.endpointErrors.external_number = ('external_number' in
              response.data)
            this.endpointErrors.internal_number = ('internal_number' in
              response.data)
            this.endpointErrors.neighborhood = ('neighborhood' in
              response.data)
            this.endpointErrors.municipality = ('municipality' in
              response.data)
            this.endpointErrors.city = ('city' in response.data)
            this.endpointErrors.zip_code = ('zip_code' in
              response.data)
            this.endpointErrors.state = ('state' in response.data)
            this.endpointErrors.type = ('type' in response.data)
            break
          default:
            break
        }
      }
    },
    submit: function () {
      this.empty = !this.$v.userInteraction.$anyDirty
      this.errors = this.$v.userInteraction.$anyError

      if (this.errors === false && this.empty === false) {
        this.sendDataToServer()
      }
    },
    getStates: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/states/',
        params: {
          country: 148
        },
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 200) {
        this.states = response.data
      }
    }
  },
  created: function () {
    this.getStates()
  }
}

</script>

<style lang="scss" scoped>

hr {
  border-color: #ccc;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepBeneficiaries.vue